<template>
    <div>
        <breadcrumb class="px-4 bg-light pb-0 mb-0" :items="breadcrumbs" />

        <div class="page-content">
            <!-- TODO: REMOVE WHEN PUSHING MASTER -->
            <h1 class="mx-0">
                Laboratory / Diagnostic
                <h3
                    v-if="isLocalEnv && labDetails"
                    style="display: inline-block;"
                    class="mb-0"
                ></h3>
            </h1>

            <InvoiceInPaymentWarning
                :invoiceId="invoiceIdLab"
                module="medical-record"
            />

            <div v-if="isLoading" class="preloader">
                <img src="assets/ajax-loader.gif" />
            </div>

            <b-card v-else footer-class="p-0" :key="cardKey">
                <lab-display
                    :mode="profileMode"
                    :isSaving="isSaving"
                    ref="labDisplay"
                    :patient="patientDetails"
                    :lab="labDetails"
                    @edit-saved="editSaved"
                />
                <template v-slot:footer no-body>
                    <b-tabs
                        card
                        class="list tab-table-responsive"
                        content-class="dashboard-list"
                        active
                    >
                        <b-tab
                            :active="selectedTab === TAB.LAB_RESULTS"
                            :key="1 + keyComponent"
                            :title-link-class="isZnLab ? 'p-0' : ''"
                            lazy
                        >
                            <template v-slot:title>
                                <b-nav-item-dropdown v-if="isZnLab">
                                    <template slot="button-content">
                                        <i class="cus-report"></i>Tests
                                    </template>
                                    <b-dropdown-item
                                        @click="displayList('LAB_RESULTS')"
                                    >
                                        <i class="cus-page-attach"></i>
                                        View Tests
                                    </b-dropdown-item>

                                    <div class="dropdown-divider"></div>

                                    <b-dropdown-item
                                        v-if="!statusInActive"
                                        @click.stop="
                                            openModal('modalNewAddOnTest')
                                        "
                                    >
                                        <i class="cus-add"></i> New Add On Test
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>
                                <template v-else>
                                    <i class="cus-report"></i>Tests
                                </template>
                            </template>
                            <b-card-text>
                                <lab-test
                                    :key="updateResultKey"
                                    :labId="labId"
                                    :isLoading="isLoading"
                                ></lab-test>
                            </b-card-text>
                        </b-tab>
                        <b-tab
                            :active="selectedTab === TAB.ATTACHMENTS"
                            :key="2 + keyComponent"
                            title-link-class="p-0"
                            lazy
                            v-if="labDetails"
                        >
                            <template v-slot:title>
                                <b-nav-item-dropdown
                                    v-if="
                                        _hasAccess('patient.attachment.view') &&
                                        isOwner(
                                            labDetails.data.record_resource
                                                .business_id
                                        )
                                    "
                                >
                                    <template slot="button-content">
                                        <i class="cus-page-white-get"></i
                                        >Attachments
                                    </template>
                                    <b-dropdown-item
                                        @click="displayList('ATTACHMENTS')"
                                    >
                                        <i class="cus-page-attach"></i>View
                                        Attachments
                                        <span v-if="counts">
                                            ({{ counts }})
                                        </span>
                                    </b-dropdown-item>

                                    <div
                                        class="dropdown-divider"
                                        v-if="!statusInActive"
                                    ></div>

                                    <b-dropdown-item
                                        v-if="
                                            _hasAccess(
                                                'patient.attachment.create'
                                            ) && !statusInActive
                                        "
                                        @click.stop="
                                            openModal('modalNewAttachment')
                                        "
                                    >
                                        <i class="cus-add"></i> New Attachment
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>
                            </template>
                            <b-card-text>
                                <attachments
                                    v-if="selectedOption === 'ATTACHMENTS'"
                                    :key="2 + keyComponent"
                                    :patientDetails="patientDetails"
                                    :labId="labId"
                                />
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </template>
            </b-card>

            <popup-notes
                v-if="profileMode !== 'EDIT'"
                :key="'popupPatient' + popupKey"
            />

            <modal-new-attachment
                v-if="patientDetails"
                @reload="reloadTab('ATTACHMENTS')"
                :patientId="patientDetails.id"
                :labId="labId"
            />

            <modal-new-addon-test
                v-if="patientDetails"
                ref="modalNewAddonTest"
                @reload="reloadPage()"
            />
        </div>
    </div>
</template>

<script>
const TAB = {
    ATTACHMENTS: "ATTACHMENTS",
    LAB_RESULTS: "LAB_RESULTS"
};

import labDisplay from "@/components/patient-lab/lab-display";
import labTest from "@/components/patient-lab/lab-test";
import PopupNotes from "@/components/patient/popup-notes";
import Attachments from "@/components/patient-documents/document-list-attachments";
import ModalNewAttachment from "@/components/patient-documents/document-add-attachment-modal";
import ModalNewAddonTest from "@/components/patient-lab/add-addon-test-modal";
import Breadcrumb from "@/components/commons/breadcrumb.vue";
import InvoiceInPaymentWarning from "@/components/invoice/invoice-in-payment-warning";
import joinPaymentInvoiceSocket from "@/mixins/join-payment-invoice-socket.js";
import EXTENSIONS from "@/constants/extensions";
import { isEmpty } from "lodash";

export default {
    mixins: [joinPaymentInvoiceSocket],
    components: {
        // patientDetail,
        labDisplay,
        labTest,
        PopupNotes,
        Attachments,
        ModalNewAttachment,
        ModalNewAddonTest,
        Breadcrumb,
        InvoiceInPaymentWarning
    },
    props: {
        profileMode: {
            type: String
        },
        isSaving: {
            type: Boolean,
            default: false
        },
        patientDetails: {
            type: Object
        },
        labDetails: {
            type: Object
        }
    },
    data() {
        return {
            counts: 0,
            cardKey: 0,
            updateResultKey: 0,
            isLoading: false,
            keyComponent: 0,
            selectedTab: null,
            selectedOption: "ATTACHMENTS",
            labId: null,
            isZnLab: false,
            TAB,
            selectedInvoiceId: null
        };
    },
    computed: {
        popupKey() {
            return this.$store.getters["patient/popupKey"];
        },
        isLocalEnv() {
            return (
                process.env.VUE_APP_ENV === "local" ||
                process.env.VUE_APP_ENV === "qa"
            );
        },
        statusInActive() {
            return this.$store.getters["patient/statusInActive"];
        },
        routeParam() {
            return this.$route.params.id;
        },
        breadcrumbs() {
            let self = this;
            let breadcrumbs = [
                {
                    text: "Patients",
                    to: {
                        name: "patient_dashboard"
                    }
                }
            ];

            if (self.$route.params.patientName) {
                breadcrumbs.push({
                    text: self.$route.params.patientName,
                    to: {
                        name: "patient_profile",
                        params: {
                            id: self.$route.params.patientId,
                            patientName: self.$route.params.patientName,
                            patientId: self.$route.params.patientId
                        }
                    }
                });
            } else {
                if (self.patientDetails) {
                    breadcrumbs.push({
                        text: self.patientDetails.fullname,
                        to: {
                            name: "patient_profile",
                            params: {
                                id: self.patientDetails.encoded_id
                            }
                        }
                    });
                }
            }

            if (self.labDetails && self.labDetails.data.record_resource) {
                breadcrumbs.push({
                    text:
                        self.labDetails.data.record_resource.item.name.length >
                        60
                            ? self.labDetails.data.record_resource.item.name.substring(
                                  0,
                                  60 - 3
                              ) + "..."
                            : self.labDetails.data.record_resource.item.name,
                    active: true
                });
            }

            return breadcrumbs;
        },
        invoiceIdLabProfile() {
            return this.$store.getters["billing/invoiceIdLabProfile"];
        },
        invoiceIdLabProfileEdit() {
            return this.$store.getters["billing/invoiceIdLabProfileEdit"];
        },
        invoiceIdLab() {
            return this.profileMode === "EDIT"
                ? this.invoiceIdLabProfileEdit
                : this.invoiceIdLabProfile;
        },
        isHasUsersChooseInvoice() {
            return this.selectedInvoiceId
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoice"](
                          this.selectedInvoiceId
                      )
                  )
                : false;
        }
    },
    watch: {
        routeParam() {
            this.getLabDetails();
            this.cardKey++;
        }
    },
    mounted() {
        this.$root.$on("antech-status-update", this.getLabDetails);

        this.getLabDetails();
    },
    sockets: {},
    destroyed() {},
    methods: {
        async getLabDetails() {
            let self = this;
            self.labId = this.$route.params.id;
            this.$store.commit("patient/setLabDetails", null);
            this.$store.commit("billing/setInvoiceIdLabProfile", null);
            this.$store.commit("billing/setInvoiceIdLabProfileEdit", null);
            window.scrollTo(0, 0);

            await this.$store
                .dispatch("patient/getLabDetails", self.labId)
                .then(async hasData => {
                    if (hasData) {
                        self.$emit("set-lab-details", hasData);
                        self.storeAudit(hasData.data.record_resource);
                        self.isZnLab =
                            hasData.data.record_resource.source &&
                            hasData.data.record_resource.source?.toUpperCase() ==
                                EXTENSIONS.CODE.CODE_ZNLABS;

                        if (hasData.data.record_resource.invoice_id) {
                            self.selectedInvoiceId =
                                hasData.data.record_resource.invoice_id;
                            self.joinPaymentInvoice(
                                hasData.data.record_resource.invoice_id,
                                joinPaymentInvoiceSocket.WITHAWAIT
                            );
                            self.$store.commit(
                                "billing/setInvoiceIdLabProfile",
                                hasData.data.record_resource.invoice_id
                            );
                        }

                        self.dynamicPageTitle(
                            `Lab: ${hasData.data.record_resource.item.name}`
                        );
                        this.getPatientDetails(
                            hasData.data.patient_resource.encoded_id
                        );
                        return hasData;
                    } else {
                        if (self.$route.params.patientId) {
                            this.$router.replace(
                                `/patient/profile/${self.$route.params.patientId}`
                            );
                        } else {
                            this.$router.push({ name: "patient_dashboard" });
                        }
                    }
                });
        },
        async getPatientDetails(encodedId) {
            var self = this;

            this.$store.commit("patient/setPatientDetails", null);

            if (encodedId) {
                this.$store.commit("patient/clearPopupNotes"); // clear popup notes by default
                this.$store.commit("patient/setDirty", false);
                await this.$store
                    .dispatch("patient/getPatientDetails", {
                        id: encodedId,
                        encoded: 1
                    })
                    .then(hasData => {
                        if (hasData) {
                            self.$emit("set-patient-details", hasData);
                        } else {
                            this.$router.push({ name: "patient_dashboard" });
                        }
                    });
            }
            self.updateResultKey++;
        },
        async storeAudit(record) {
            const labId = _.clone(record.id);
            const fullPath = _.clone(this.$router.currentRoute.fullPath);

            if (!labId) {
                return;
            }

            await this._getSetting();
            await this._saveAudit({
                action: "view",
                path: "/patient/lab/" + labId,
                reference_id: labId,
                fullPath
            });
        },
        reloadTab(tabName) {
            var self = this;

            // add delay to before reload tab to allow new update reflected
            setTimeout(() => {
                self.keyComponent++;
                self.selectedTab = tabName ? TAB.ATTACHMENTS : TAB.LAB_RESULTS;
            }, 1000);
        },
        reloadPage() {
            this.getLabDetails();
        },
        displayList(code) {
            this.keyview += 1; // force re-render if same menu item is selected
            this.selectedOption = code;
        },
        openModal(code) {
            if (code === "modalNewAttachment") {
                this.$store.commit("patient/openModalNewAttachment", {
                    patient_id: this.patientDetails.id,
                    record_id: this.labId,
                    soap_id: this.labDetails.data.record_resource.soap_id
                });
            } else if (code === "modalNewAddOnTest") {
                this.$refs.modalNewAddonTest.open({
                    lab_pid: this.labDetails.data.record_resource.lab_pid,
                    id: this.labDetails.data.record_resource.id
                });
            }
        },
        saveEditLab() {
            this.$refs.labDisplay.saveEdit();
        },
        async editSaved(details) {
            if (
                details &&
                details.lab_id &&
                this.$route.params.id != details.lab_id
            ) {
                this.$router.replace(`/patient/lab/${details.lab_id}`);
            } else {
                await this.getLabDetails();
            }

            this.$emit("edit-saved", details);
        }
    }
};
</script>
